import { Component, Injector, OnInit } from '@angular/core';
import { ActiveModal } from '../../../modals/classes/active-modal';
import { CategoryCreateForm } from '../../forms/category/create.form';
import { CategoryModel } from '../../models/category.model';
import { CategoryService } from '../../services/category.service';
import { ChassisFormHandler } from '../../../forms/form/classes/form-handler';

@Component({
    selector: 'chassis-core-category-create-modal',
    templateUrl: 'create.modal.html',
    styleUrls: ['create.modal.scss']
})
export class CreateCategoryModal implements OnInit {

    /**
     * Title of the modal
     *
     * @type {string}
     */
    private title = 'Create category';

    /**
     * The ChassisFormHandler form instance.
     */
    public form: ChassisFormHandler;

    /**
     * The CategoryModel instance.
     */
    protected model: CategoryModel;

    constructor(
        protected modal: ActiveModal,
        protected injector: Injector,
        protected categoryService: CategoryService,
    ) {
    }

    ngOnInit() {
        this.createForm();
    }

    /**
     * Create the form.
     */
    protected createForm() {
        this.model = this.categoryService.make();

        this.form = new ChassisFormHandler(this.injector, CategoryCreateForm, this.model);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/categories/modals/create/create.modal.ts